import {inject, injectable} from "inversify";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";
import {AbstractApiProvider} from "data/providers/api/abstract.api.provider";
import {IPromptParams} from "data/types/api";
import {IPrompt} from "data/stores/promo_banner/promo_banner.store";

export type TPromptResponse = IApiResponse<IPrompt>;

export interface IPromptApiProvider {
	get: (params: IPromptParams) => Promise<AxiosResponse<TPromptResponse>>;
	decline: (params: IPromptParams) => Promise<AxiosResponse<TPromptResponse>>;
}

@injectable()
export class PromptApiProvider extends AbstractApiProvider implements IPromptApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {
		super();
	}

	get = (params: IPromptParams) =>
		this._http.get<TPromptResponse>(`${this.language}/prompt/show`, params);
	decline = (params: IPromptParams) =>
		this._http.get<TPromptResponse>(`${this.language}/prompt/decline`, params);
}
